import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { Navbar } from "../../../components/nav";
import { MonitoramentoSetoresList } from "./components/monitoramento-setores-list/monitoramento-setores-list";
import { useStyles } from "./monitoramento-setores-styles";

const MonitoramentoSetoresPage = () => {

   const classes = useStyles();

   return (
      <>
         <PublicPageHeader topOpacity="0.8" />
         <div className={classes.root}>
            <Navbar titulo="Monitoramento" />
            <MonitoramentoSetoresList />
         </div >
      </>
   )
};

export default MonitoramentoSetoresPage
